import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface InfoDialogData {
  title: string;
  content: string;
  buttonText?: string;
}

@Component({
  selector: 'lib-info-dialog',
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-dialog-content [innerHtml]="content"></mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close>{{ buttonText }}</button>
    </mat-dialog-actions>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialogComponent {
  private dialogData = inject(MAT_DIALOG_DATA) as InfoDialogData;

  title = this.dialogData.title;
  content = this.dialogData.content;
  buttonText = this.dialogData.buttonText ?? 'Close';
}
